/**
 * Shared table utilities — used by DataTable and DrillDownPanel.
 * Single source of truth for formatting and classification helpers.
 */

// Metadata columns that are not displayed as value columns (financial mode)
export const META_COLS = new Set(['row_type', 'category', 'depth', 'label']);

/**
 * Format a numeric value as currency with $ prefix.
 * Returns empty string for null/undefined/empty.
 */
export function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'number' ? value : Number(value);
  if (isNaN(num)) return String(value);
  const formatted = Math.abs(num).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (num < 0) return `-$${formatted}`;
  return `$${formatted}`;
}

/**
 * Smart value formatting — detects currency columns by name,
 * otherwise formats as a plain number or string.
 */
export function formatValue(value, colName) {
  if (value === null || value === undefined) return '\u2014';
  const num = typeof value === 'number' ? value
    : (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value.trim())) ? Number(value) : null;

  if (num !== null && isFinite(num)) {
    const lower = (colName || '').toLowerCase();
    const isCurrency = lower.includes('revenue') || lower.includes('amount') || lower.includes('expense')
      || lower.includes('cost') || lower.includes('income') || lower.includes('profit')
      || lower.includes('balance') || lower.includes('total') || lower.includes('price')
      || lower.includes('spend') || lower.includes('sales');
    if (isCurrency) {
      return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  if (typeof value === 'string' && value.endsWith('%')) return value;
  return String(value);
}

/**
 * Check if a value is numeric (number type or numeric string).
 */
export function isNumeric(value) {
  if (typeof value === 'number' && isFinite(value)) return true;
  if (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value.trim())) return true;
  return false;
}
